import { motion } from "framer-motion";
import { Phone, Globe, ArrowUpRight, MapPin } from "lucide-react";

export const Footer = ({ onApply }) => {
  return (
    <footer id="contact" className="bg-oed-surface border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs uppercase tracking-[0.3em] text-oed-gold mb-6">Ready to own your territory?</p>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.92] text-5xl md:text-7xl lg:text-8xl max-w-4xl">
            Build Freedom.<br />Build Wealth.<br /><span className="text-oed-gold">Build Legacy.</span>
          </h2>
          <button
            data-testid="footer-apply-button"
            onClick={onApply}
            className="mt-10 inline-flex items-center gap-3 bg-white text-black px-9 py-4 text-sm font-medium hover:bg-oed-gold transition-colors"
          >
            Apply for a Dealership <ArrowUpRight size={18} />
          </button>
        </motion.div>

        <div className="mt-20 grid md:grid-cols-3 gap-10 border-t border-white/10 pt-12">
          <div>
            <img src="/logo.png" alt="OED Glampire Network" className="h-20 w-20 object-contain" />
            <p className="mt-4 font-display font-black text-lg tracking-tighter">OED GLAMPIRE NETWORK</p>
            <p className="mt-3 text-sm text-white/40 max-w-xs leading-relaxed">
              The future of off-grid living, tiny-home communities & luxury glamping resorts.
            </p>
            <p className="mt-4 flex items-start gap-3 text-sm text-white/50">
              <MapPin size={16} className="mt-0.5 shrink-0 text-oed-gold" />
              43106 US Hwy 280, Lineville, AL 36266
            </p>
          </div>
          <div className="space-y-4">
            <a href="tel:2562687146" data-testid="footer-phone" className="flex items-center gap-3 text-white/70 hover:text-oed-gold transition-colors">
              <Phone size={16} /> 256-268-7146
            </a>
            <a href="https://oedglampire.com" target="_blank" rel="noreferrer" data-testid="footer-website" className="flex items-center gap-3 text-white/70 hover:text-oed-gold transition-colors">
              <Globe size={16} /> oedglampire.com
            </a>
          </div>
          <div className="space-y-4">
            <a href="https://oedglampirenetwork.base44.app" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/70 hover:text-oed-gold transition-colors">
              Glampire Network <ArrowUpRight size={14} />
            </a>
            <a href="https://oedglampire-stores.base44.app/tiny-homes" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/70 hover:text-oed-gold transition-colors">
              Tiny Homes Store <ArrowUpRight size={14} />
            </a>
            <a href="/admin/login" data-testid="footer-admin-link" className="flex items-center gap-2 text-white/30 hover:text-white/60 transition-colors text-sm">
              Dealer Admin
            </a>
          </div>
        </div>

        <p className="mt-12 text-[11px] text-white/25 leading-relaxed max-w-3xl">
          © {new Date().getFullYear()} OED Glampire Network. Revenue potential depends on market conditions,
          sales performance, execution and other business factors. Illustrative projection, not a guarantee of earnings.
        </p>
      </div>
    </footer>
  );
};
